import {init_choices, notifier, on, post, slideDown, slideUp, val} from "../util";

declare let eo_crafting_id : number;

export default class {
    static init = () => {
        craft();
    }
}

function craft() {
    if(typeof eo_crafting_id == 'undefined') {
        return;
    }

    on('click','.js-add-materials',(target : HTMLButtonElement) => {
        let row = (document.querySelector('.row-materials-template') as HTMLDivElement).cloneNode(true) as HTMLDivElement;
        row.classList.remove('row-materials-template', 'd-none');
        row.querySelector('.js-choices')?.classList.remove('choices__input');

        let wrapper = document.querySelector('.js-materials-wrapper') as HTMLDivElement;
        wrapper.appendChild(row);

        slideDown(row, 500, () => {
            init_choices();
        });
    },true);

    on('click','.js-remove-materials',(target : HTMLButtonElement) => {
        let row = target.closest('.row-materials') as HTMLDivElement;
        let id = parseInt(row.dataset.materials_id ?? "0");
        slideUp(row, 500, () => {
            post('?do=removeMaterial', {
                crafting_id: eo_crafting_id,
                materials_id: id
            },(data : any) => {
                if(data.status == 1) {
                    notifier.success(data.message);
                    row.remove();
                } else {
                    notifier.error(data.message);
                    row.style.display = 'block';
                }
            });
        });
    },true);

    on('change','.js-items_id', save_crafting);
    on('change','.js-eo-craft-amount', save_crafting);
    on('change','.js-materials-amount', (element : HTMLElement) => save_material(element), true);
    on('change','.js-materials-items_id', (element : HTMLElement) => save_material(element), true);

    on('change','.js-eo-crafts',(target : HTMLInputElement) => {
        let id = parseInt(target.value ?? "0");
        if(isNaN(id)) {
            id = 0;
        }
        window.location.href = '/eo/crafting/' + id;
    });
}

function save_crafting() {
    let items_id_el = document.querySelector('.js-items_id') as HTMLSelectElement;
    let amount_el = document.querySelector('.js-eo-craft-amount') as HTMLInputElement;
    post('?do=saveCrafting', {
        crafting_id: eo_crafting_id,
        items_id: items_id_el ? items_id_el.value : '',
        amount: amount_el ? amount_el.value : ''
    },(data : any) => {
        if(data.status == 1) {
            eo_crafting_id = data.crafting_id;
            let url = new URL(window.location.origin + '/eo/crafting/' + eo_crafting_id);
            window.history.replaceState({}, '', url.toString());
            notifier.success(data.message);
        } else {
            notifier.error(data.message);
        }
    });
}

function save_material(element : HTMLElement) {
    let row = element.closest('.row-materials') as HTMLDivElement;
    let id = parseInt(row.dataset.materials_id ?? "0");
    let items_id_el = row.querySelector('.js-materials-items_id') as HTMLSelectElement;
    let amount_el = row.querySelector('.js-materials-amount') as HTMLInputElement;
    let items_id = items_id_el ? items_id_el.value : '';
    let amount = amount_el ? amount_el.value : '';
    post('?do=saveMaterial', {
        crafting_id: eo_crafting_id,
        materials_id: id,
        items_id: items_id,
        amount: amount
    },(data : any) => {
        if(data.status == 1) {
            row.dataset.materials_id = data.materials_id;
            notifier.success(data.message);
        } else {
            notifier.alert(data.message);
        }
    });
}
